import _orderBy from 'lodash/orderBy'

class MyDevicesTabController {
  constructor ($log, ProductService, VehicleService, SDFilterService, $state, $scope, $rootScope, $anchorScroll) {
    'ngInject'
    this.productService = ProductService
    this.vehicleService = VehicleService
    this.sdFilterService = SDFilterService
    this.$state = $state
    this.$scope = $scope
    this.$rootScope = $rootScope

    this.devices = []
    this.isProcessing = true

    this.$log = $log
    // SD filter
    this.filterBtn = false
    this.displayAllBtn = false
    this.sdCartCount = 0
    this.sdFilterList = []
    this.sdDevicesWithStatusTrue = 0
    // Async loading...
    $anchorScroll()
    this.loaded = this.init()
  }

  init () {
    return this.vehicleService.getCurrentSelectedVehicle(false)
      .then((vehicle) => {
        if (!vehicle) {
          return Promise.reject()
        }
        if (vehicle.mandatoryUpdate) {
          return this.$state.go('installation')
        }
        this.vehicle = vehicle
        this.descriptionLabel = 'my-updates.device.description'
        if (vehicle.huType === 'MM12') {
          this.descriptionLabel += '.mm12'
        } else if (vehicle.huType === 'RADNAV') {
          this.descriptionLabel += '.radnav'
        }
        this.$log.debug('getProductsOnDevices')
        return this.vehicleService.getProductsOnDevices(this.vehicle.vin)
      })
      .then((res) => {
        this.isProcessing = false
        this.error = null
        this.muid = res.muid
        this.devices = _orderBy(res.deviceMounts.deviceMount, ['mountId'], ['asc'])
        this.safeApply()
        this.initSDFilterParam()
        return Promise.resolve(this.devices)
      }, (err) => {
        this.isProcessing = false
        this.error = {
          message: 'my-updates.error',
          cause: err
        }
        this.safeApply()
        return Promise.reject(err)
      })
  }

  safeApply () {
    const phase = this.$rootScope.$$phase
    if (phase !== '$apply' && phase !== '$digest') {
      this.$scope.$apply()
    }
  }

  synchronize (device, syncProducts) {
    // this.$log.debug('Synchronize')
    this.isProcessing = true
    this.error = null
    return this.vehicleService.synchronizeDeviceMount(this.vehicle.vin, this.muid, device.mountId, syncProducts)
      .then(() => {
        // this.$log.debug('Device synchronized')
        this.isProcessing = false
        this.$state.go('installation')
      }, (err) => {
        this.$log.error('An error occurred during synchronization')
        this.isProcessing = false
        if (err.data && err.data.meta) {
          // 507 - SC_INSUFFICIENT_STORAGE (insufficient total space)
          // 419 - SC_INSUFFICIENT_SPACE_ON_RESOURCE (insufficient free space)
          if (err.data.meta.statusCode === 507 && this.vehicle.huType === 'MM12') {
            this.error = {
              message: 'my-updates.device.synchronization_not_enough_total_space_mm12',
              cause: err
            }
          } else if (err.data.meta.statusCode === 507 && this.vehicle.huType === 'RADNAV') {
            this.error = {
              message: 'my-updates.device.synchronization_not_enough_total_space_radnav',
              cause: err
            }
          } else if (err.data.meta.statusCode === 419) {
            this.error = {
              message: 'my-updates.device.synchronization_not_enough_free_space',
              cause: err
            }
          }
        } else {
          this.error = {
            message: 'my-updates.device.synchronization_error',
            cause: err
          }
        }
      })
  }

  initSDFilterParam () {
    this.sdCartCount = 0
    this.sdFilterList = []
    this.devices.forEach(device => {
      if (device.mountType === 'SD Card') {
        this.sdCartCount++
        this.sdFilterList[device.mountId] = true // display all
      }
    })
    if (this.sdCartCount < 2) {
      this.sdFilterList = []
    } else {
      this.filterBtn = true
      this.getUserSDFilter()
    }
  }

  applyUserSDFilter (callRes) {
    if (callRes.status === true) {
      this.filterBtn = true
      this.displayAllBtn = false
    } else if (callRes.status === false) {
      this.filterBtn = false
      this.displayAllBtn = true
    }
    if (callRes.deviceSDFilterList != null) {
      callRes.deviceSDFilterList.forEach(device => {
        this.sdFilterList[device.mountId] = device.status
      })
    }
    this.sdDevicesWithStatusTrue = 0
    for (var mountId in this.sdFilterList) {
      if (this.sdFilterList[mountId]) {
        this.sdDevicesWithStatusTrue++
      }
    }
    return callRes
  }

  getUserSDFilter () {
    return this.sdFilterService.getUserSDFilter().then((res) => {
      return this.applyUserSDFilter(res)
    })
  }

  getSDDeviceStatus (mountId) {
    if (this.sdFilterList[mountId] !== undefined) {
      if (this.sdFilterList[mountId] === true) {
        if (this.sdDevicesWithStatusTrue === 1) { // at minimum one should be show
          return ''
        }
        return 'display'
      } else {
        if (this.displayAllBtn === true) {
          return 'hide'
        }
        return 'disabled'
      }
    }
    return 'none'
  }

  makeFiltered () {
    return this.sdFilterService.changeUserSDFilterStatus('hide').then((res) => {
      return this.getUserSDFilter()
    })
  }

  showAll () {
    return this.sdFilterService.changeUserSDFilterStatus('show').then((res) => {
      return this.getUserSDFilter()
    })
  }

  getDeviceStyleClass (mountId) {
    let line = this.getSDDeviceStatus(mountId)
    if (line === 'hide') {
      return 'hideBox'
    }
    return ''
  }

  filterAction () {
    return this.getUserSDFilter()
  }

  showHideBeforeApiCall (mountId, show) {
    this.sdFilterList[mountId] = show
  }
}

export default MyDevicesTabController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/my-updates/my-devices-tab/my-devices-tab.controller.js